// extracted by mini-css-extract-plugin
export default {"title":"Page_title__wrqUA","info":"Page_info__CDwph"};